"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var FormActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/FormActions"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _SkeletonDurationPicker = _interopRequireDefault(require("MeetingsLib/components/schedule/duration/SkeletonDurationPicker"));

var _DurationPicker = _interopRequireDefault(require("MeetingsLib/components/schedule/duration/DurationPicker"));

var _SkeletonTimePicker = _interopRequireDefault(require("MeetingsLib/components/schedule/time/SkeletonTimePicker"));

var _TimePicker = _interopRequireDefault(require("MeetingsLib/components/schedule/time/TimePicker"));

var _StepButtonsFooter = _interopRequireDefault(require("MeetingsLib/components/page/StepButtonsFooter"));

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var TimeOptionsSection = (0, _createReactClass.default)({
  displayName: "TimeOptionsSection",
  propTypes: {
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    compact: _propTypes.default.bool.isRequired,
    isFetchingPublicAvailability: _propTypes.default.bool.isRequired,
    goToPreviousStep: _propTypes.default.func,
    profile: _propTypes.default.instanceOf(_UserProfile.default).isRequired,
    resetEventDateTime: _propTypes.default.func.isRequired,
    TimePickerMarker: _propTypes.default.func.isRequired
  },
  handleGoToPreviousStep: function handleGoToPreviousStep() {
    var _this$props = this.props,
        resetEventDateTime = _this$props.resetEventDateTime,
        goToPreviousStep = _this$props.goToPreviousStep;
    resetEventDateTime();
    goToPreviousStep();
  },
  renderTimePicker: function renderTimePicker() {
    var _this$props2 = this.props,
        branding = _this$props2.branding,
        compact = _this$props2.compact,
        isFetchingPublicAvailability = _this$props2.isFetchingPublicAvailability,
        profile = _this$props2.profile,
        TimePickerMarker = _this$props2.TimePickerMarker;

    if (isFetchingPublicAvailability) {
      return _react.default.createElement(_SkeletonTimePicker.default, null);
    }

    return _react.default.createElement(_TimePicker.default, {
      branding: branding,
      compact: compact,
      profile: profile,
      TimePickerMarker: TimePickerMarker
    });
  },
  renderDurationPicker: function renderDurationPicker() {
    if (this.props.isFetchingPublicAvailability) {
      return _react.default.createElement(_SkeletonDurationPicker.default, null);
    }

    return _react.default.createElement(_DurationPicker.default, null);
  },
  renderStepButtonsFooter: function renderStepButtonsFooter() {
    var _this$props3 = this.props,
        branding = _this$props3.branding,
        compact = _this$props3.compact;

    if (!compact) {
      return null;
    }

    return _react.default.createElement(_StepButtonsFooter.default, {
      branding: branding,
      goToPreviousStep: compact ? this.handleGoToPreviousStep : null
    });
  },
  render: function render() {
    return _react.default.createElement(_UICardWrapper.default, {
      className: "p-all-8 m-bottom-0 height-100"
    }, _react.default.createElement(_UICardSection.default, {
      flush: true,
      className: "p-top-0 m-bottom-0 height-100"
    }, this.renderDurationPicker(), this.renderTimePicker(), this.renderStepButtonsFooter()));
  }
});

var _default = (0, _reactRedux.connect)(null, FormActions)(TimeOptionsSection);

exports.default = _default;
module.exports = exports.default;